import { render } from "./ExamConsentOffcanvas.vue?vue&type=template&id=6d23acb5&scoped=true"
import script from "./ExamConsentOffcanvas.vue?vue&type=script&lang=js"
export * from "./ExamConsentOffcanvas.vue?vue&type=script&lang=js"

import "./ExamConsentOffcanvas.vue?vue&type=style&index=0&id=6d23acb5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d23acb5"]])

export default __exports__